<template>
  <div>
    <div class="container px-8 pt-8 mx-auto lg:px-16">
      <h2 id="soutenir" class="text-4xl font-bold tracking-wider uppercase font-raleway">Nous soutenir</h2>
      <hr class="mb-10 antialiased border border-green-500" />

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
        <div class="mb-8 text-center lg:mb-0">
          <a
            href="https://www.instagram.com/herdingcatstech/"
            target="_blank"
            rel="noopener noreferrer"
            class="block w-24 h-24 p-4 mx-auto bg-green-500 rounded-full hover:bg-green-700 md:w-32 md:h-32 md:p-8"
          >
            <svgInstagram class="text-white fill-current"/>
          </a>
          <p class="mt-4 mb-2 font-bold text-green-500 uppercase">INSTAGRAM</p>
          <p class="px-8 ">Votre dose de douceur quotidienne&nbsp;!</p>
        </div>
        <div class="mb-8 text-center lg:mb-0">
          <a
            href="https://www.facebook.com/herdingcat/"
            target="_blank"
            rel="noopener noreferrer"
            class="block w-24 h-24 p-4 mx-auto bg-green-500 rounded-full hover:bg-green-700 md:w-32 md:h-32 md:p-8"
          >
            <svgFacebook class="text-white fill-current"/>
          </a>
          <p class="mt-4 mb-2 font-bold text-green-500 uppercase">Facebook</p>
          <p class="px-8 ">Entrez dans les coulisses de la team&nbsp;! </p>
        </div>
        <div class="mb-8 text-center lg:mb-0">
          <a
            href="https://twitter.com/herdingcats8"
            target="_blank"
            rel="noopener noreferrer"
            class="block w-24 h-24 p-4 mx-auto bg-green-500 rounded-full hover:bg-green-700 md:w-32 md:h-32 md:p-8"
          >
            <svgTwitter class="text-white fill-current"/>
          </a>
          <p class="mt-4 mb-2 font-bold text-green-500 uppercase">TWITTER</p>
          <p class="px-8">Pour suivre toutes nos actualités&nbsp;!</p>
        </div>
        <div class="relative w-auto h-auto mb-8 text-center lg:mb-0">
          <a
            href="https://www.linkedin.com/company/herdingcats/"
            target="_blank"
            rel="noopener noreferrer"
            class="relative z-20 block w-24 h-24 p-4 mx-auto bg-green-500 rounded-full hover:bg-green-700 md:w-32 md:h-32 md:p-8"
          >
            <svgLinkedin class="z-20 text-white fill-current"/>
          </a>
          <img
            src="svg/pelotte.svg"
            class="absolute bottom-0 right-0 z-0 hidden w-32 h-auto mb-24 mr-2 md:block"
          >
          <p class="mt-4 mb-2 font-bold text-green-500 uppercase">LINKEDIN</p>
          <p class="px-8">Notre quartier général félin professionnel</p>
        </div>
      </div>
    </div>
    <svgPelotte class="w-40 h-auto -mr-1 text-green-500 fill-current hover:text-green-700 md:hidden"/>
  </div>
</template>

<script>
  import svgInstagram from "../assets/svg/instagram.svg";
  import svgFacebook from "../assets/svg/facebook.svg";
  import svgTwitter from "../assets/svg/twitter.svg";
  import svgLinkedin from "../assets/svg/linkedin.svg";
  import svgPelotte from "../assets/svg/pelotte.svg";

  export default {
    name: "Soutenir",
    components: {
      svgInstagram,
      svgFacebook,
      svgTwitter,
      svgLinkedin,
      svgPelotte
    }

  };
</script>

<style>
</style>